import { UiContainer } from '../../state/ui';
import { ApiProductPage } from '../../types';
import { useConfig } from '../../config';
import { calculateVatMultiplier } from '../../utils/vatUtils';

function buildJsonLd({
	product,
	priceWithVat,
	currencyCode,
	domain,
}: {
	product: ApiProductPage;
	priceWithVat: boolean;
	currencyCode: string;
	domain: string;
}) {
	const { id, image, name, brand, minQuantity, price, campaignPrice, vatRate, perma, gtin, mpn, schemaAvailability } =
		product;

	const vatScale = calculateVatMultiplier(vatRate, priceWithVat);

	const data = {
		'@context': 'http://schema.org/',
		'@type': 'product',
		name,
		image: image,
		gtin13: gtin,
		mpn: mpn,
		sku: id,
		offers: {
			'@type': 'Offer',
			url: `https://${domain}/${perma}`,
			priceCurrency: currencyCode,
			price: ((campaignPrice && campaignPrice > 0 ? campaignPrice : price) * vatScale * minQuantity).toFixed(2),
			itemCondition: 'http://schema.org/NewCondition',
			availability: 'http://schema.org/' + schemaAvailability,
			priceSpecification:
				minQuantity > 1
					? {
							'@type': 'UnitPriceSpecification',
							eligibleQuantity: {
								'@type': 'QuantitativeValue',
								minValue: minQuantity,
							},
						}
					: undefined,
		},
		brand: {
			'@type': 'Thing',
			name: brand.name,
		},
	};

	return JSON.stringify(data);
}

export function useJsonLD(product: ApiProductPage | undefined): string {
	const ui = UiContainer.useContainer();
	const { currencyCode, domain } = useConfig();

	if (!product) return '';

	return buildJsonLd({
		product,
		priceWithVat: ui.priceWithVat,
		currencyCode,
		domain,
	});
}
